import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/billing/statistics';

export default {

    getBillingStatistics(month) {
        return axios.get(BASE_URL + '?months=' + month);
    },

}
